// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"lo5C2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSafariPinnedTab = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 2222.667,
        height: 2222.667,
        viewBox: "0 0 1667 1667",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M210.8 1.5c-45.4 6.2-86.6 24-122.3 52.8-10.2 8.2-30.3 28.8-38.1 39.2-22.9 30.1-38.6 64-45.9 99.2C-.3 215.9 0 180.1 0 833.5c0 662.2-.4 617.9 5.1 643.5 3 13.7 11.1 37.5 17.4 50.7 28.5 60 79.7 105.7 142.2 126.8 12 4.1 22.5 6.7 38.8 9.8l11 2.1 612 .3c669.5.4 623.1.8 650.4-5.3 35.1-7.7 70-24.4 99.3-47.4 10.6-8.3 29.5-27.2 37.8-37.8 23-29.3 39.7-64.2 47.4-99.3 6.1-27.3 5.7 19.1 5.3-650.4l-.3-612-2.1-11c-3.1-16.3-5.7-26.8-9.8-38.8-29.7-87.9-106.8-151.1-198.8-163.2C1445.2.2 1377.9 0 832.2.1 330.1.2 218.8.4 210.8 1.5zM1405.2 165c45.5 4.3 81.9 35.5 94.1 80.5l2.2 8 .3 575c.2 423.4 0 577.1-.8 583-6.5 45.4-44.1 83-89.5 89.5-5.9.8-159.6 1-583 .8l-575-.3-8-2.2c-45.3-12.3-76.5-49-80.5-94.7-1.3-15.1-1.3-1127 0-1142.1.5-6.1 1.9-14.6 3-19 2.6-10.1 11.4-28 17.9-36.6 17.8-23.4 45.6-39 74.3-41.8 12.7-1.3 1132.1-1.3 1145-.1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1194.1 218c-14 3-28.2 9.6-41.1 19.4-12 9.1-537.1 534.7-543 543.5-6.1 9.2-11.6 21.5-14.2 31.7-3.2 12.7-3.2 35.1 0 47.9 2.7 10.9 10.3 26.7 17.1 35.5 2.7 3.6 124.6 126 270.8 272.1 276.9 276.7 270.3 270.3 286.8 278.6 19 9.6 43.5 12.2 64.1 6.9 23-6 45.4-22.3 58.8-42.8 11.3-17.3 15.9-32.8 15.9-52.8 0-18.6-4.2-33.2-14.4-50-4.8-7.8-23.1-26.5-236.3-239.7L827.5 837l229.6-229.7c180.6-180.8 230.7-231.5 234.8-237.6 12.3-18.1 17.5-34.5 17.4-54.7 0-20.1-4.6-35.5-15.7-52.5-13-19.9-32.2-34.4-55.6-42-7.5-2.5-10.3-2.8-24-3.1-8.5-.2-17.5.1-19.9.6zM497.3 1098c-61.5 6.5-112.4 46-129.6 100.6-5.2 16.3-6.2 24.1-6.2 48.4 0 19.9.3 23.7 2.3 32.9 13.5 60.1 58.9 105.7 118.3 118.7 11.9 2.7 47.6 2.7 59.9.1 60.9-12.8 108-59.7 120.1-119.6 4.1-20.3 3.6-51.2-1.3-71.1-13.5-55.3-61-98.3-120-108.4-11.1-2-32.8-2.7-43.5-1.6z"
            })
        ]
    });
exports.default = SvgSafariPinnedTab;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["lo5C2"], "lo5C2", "parcelRequiree54f")

//# sourceMappingURL=safari-pinned-tab.0b3aab82.js.map
